module.exports = {

	methods: {
		getArticleImage(article){

            var url = false;

            $.each(article.posterImages, function(){

                if(this.posterSizes.includes(article.size)){
                    url = this.URL
                }

            })

            return window.appSettings.productImageUrl  + "/" + url
        },

        getArticleImageDB(article){
			if(typeof article.images != 'undefined')
				return window.appSettings.productImageUrl + "/" + article.images[0].URL;
		},
	}
	
};



// WEBPACK FOOTER //
// ./client/mixins/images.js